import { combineReducers, configureStore } from '@reduxjs/toolkit'
import  login from './component/security/slice-login'
import commonupload from './component/common/slice-upload'
import ticketInventory from './component/ticketinventory/slice-ticketInventory'
import master from './component/common/slice-master';
import datatable from './component/common/slice-datatable'
import itineraryquotation from './component/itinerary/slice-itineraryquotation'
import { reducers } from './moduleconfiguration';
import ticketAndTour from './component/master/ticketsntour/slice-ticket-and-tour';
import supplierData from './component/master/supplydata/slice-supplier-data';
import sliceDynamicselect from './component/common/slice-dynamicselect';

import businessProvider from './component/master/businessProvider/slice-business-provider';
import businessFrom from './component/master/businessProvider/slice-business-from';
import bankAccount from './component/master/bankAccounts/slice-bank';
import hotelMaster from './component/master/hotelDetails/slice-hotel';
import hierarchicalElement from './component/common/slice-hierarchical-element';
import userHierarchyAssignment from './component/common/slice-user-hierarchy-assignment';

const rootReducer = combineReducers({
  login,
  commonupload,
  ticketInventory,
  master,
  datatable,
  itineraryquotation,
  ticketAndTour,
  selectdynamic: sliceDynamicselect,
  supplierData,
  businessProvider,
  businessFrom,
  bankAccount,
  hotelMaster,
  hierarchicalElement,
  userHierarchyAssignment,
  httpapierros: (state:any={}, payload:any={type: 'NOTDHENDD', data: 1}) => {
  
  return state;
},
...reducers()
})

 const setupStore = (preloadedState?:any) => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  })
}
export const store = setupStore()
export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']
